__turbopack_context__.v({
  "disabled": "seThUW_disabled",
  "discountSection": "seThUW_discountSection",
  "errorButton": "seThUW_errorButton",
  "errorContentWrapper": "seThUW_errorContentWrapper",
  "footerButton": "seThUW_footerButton",
  "footerWrapper": "seThUW_footerWrapper",
  "highlightedPaymentMethodWrapper": "seThUW_highlightedPaymentMethodWrapper",
  "infoExtraStickyWrapper": "seThUW_infoExtraStickyWrapper",
  "infoExtraWrapper": "seThUW_infoExtraWrapper",
  "infoWrapper": "seThUW_infoWrapper",
  "originalPriceWithCurrency": "seThUW_originalPriceWithCurrency",
  "price": "seThUW_price",
  "priceDetailsSection": "seThUW_priceDetailsSection",
  "priceInfoBoxWrapper": "seThUW_priceInfoBoxWrapper",
  "priceInfoBoxWrapperNotSticky": "seThUW_priceInfoBoxWrapperNotSticky",
  "priceOverviewTitle": "seThUW_priceOverviewTitle",
  "priceSectionSticky": "seThUW_priceSectionSticky",
  "priceSticky": "seThUW_priceSticky",
  "priceText": "seThUW_priceText",
  "route": "seThUW_route",
  "serviceIconDivider": "seThUW_serviceIconDivider",
  "services": "seThUW_services",
  "skeletonBody": "seThUW_skeletonBody",
  "skeletonDesktopButton": "seThUW_skeletonDesktopButton",
  "skeletonPrice": "seThUW_skeletonPrice",
  "skeletonPriceInfoBox": "seThUW_skeletonPriceInfoBox",
  "skeletonProgressCircle": "seThUW_skeletonProgressCircle",
  "skeletonStickyBarBody": "seThUW_skeletonStickyBarBody",
  "skeletonWrapper": "seThUW_skeletonWrapper",
  "stickyBar": "seThUW_stickyBar",
  "stickyBarButton": "seThUW_stickyBarButton",
  "stickyBarColumnLeft": "seThUW_stickyBarColumnLeft",
  "stickyBarColumnRight": "seThUW_stickyBarColumnRight",
  "stickyBarContent": "seThUW_stickyBarContent",
  "stickyBarContentTinted": "seThUW_stickyBarContentTinted",
  "wrapper": "seThUW_wrapper",
});
